import React, { useState } from "react"
import weefLogo from "../assets/svg/WEEF.svg"
import style from "../components/headerMobile.module.scss"
import menuIcon from "../assets/svg/icon_menu.svg"
import borduursel from "../assets/svg/borduursel.svg"
import { AnimatePresence, motion } from "framer-motion"
import ResultaatMobile from "./resultaatMobile"
import scrollTo from "gatsby-plugin-smoothscroll"

export default function HeaderMobile() {
  const [menu, setMenu] = useState(false)
  const [showResultaat, setShowResultaat] = useState(true)

  const links = [
    "wat is WEEF",
    "geschiedenis",
    "kunstenaars",
    "resultaat",
    "contact",
  ]
  return (
    <div className={style.wrapper}>
      {showResultaat && <ResultaatMobile></ResultaatMobile>}
      <img
        src={weefLogo}
        style={{
          zIndex: "1",
          maxWidth: "7.5rem",
          pointerEvents: "visible",
          cursor: "pointer",
        }}
        onClick={() => {
          scrollTo("#landing")
          setShowResultaat(false)
        }}
        alt="weef_logo"
      ></img>
      <button onClick={() => setMenu(!menu)}>
        <img src={menuIcon} alt="menu"></img>
      </button>
      {/* <NavigationMobile
        show={menu}
        links={[
          "wat is WEEF",
          "geschiedenis",
          "kunstenaars",
          "resultaat",
          "contact",
        ]}
      ></NavigationMobile> */}
      <AnimatePresence>
        {menu && (
          <motion.nav
            className={style.nav}
            initial={{ marginLeft: window.innerWidth }}
            animate={{ marginLeft: 0 }}
            exit={{ marginLeft: window.innerWidth }}
            // transition = {{duration:0.3}}
          >
            {links.map((linkName, index) => {
              return (
                <div className={style.combine}>
                  <a
                    className={style.link}
                    onClick={() => {
                      linkName !== "resultaat" &&
                        scrollTo(
                          `#${
                            linkName === "wat is WEEF" ? "watisweef" : linkName
                          }`
                        )

                      setMenu(false)
                      linkName !== "resultaat" && setShowResultaat(false)
                      linkName === "resultaat" &&
                        setShowResultaat(!showResultaat)
                    }}
                    style={{
                      gridColumn: { index },
                      pointerEvents: "visible",
                      cursor: "pointer",
                    }}
                    key={linkName}
                  >
                    {linkName}
                  </a>
                  {linkName !== "contact" && (
                    <img src={borduursel} alt="borduursel"></img>
                  )}
                </div>
              )
            })}
          </motion.nav>
        )}
      </AnimatePresence>
    </div>
  )
}
